// A failed write on a record's Holdings or Transactions tab (#14991): an
// error toast with the server's sentence, or a plain one when it gave none.
// A write the user started and that did not happen is not an intended
// outcome, so it is said out loud (Hunter, 2026-11-02: "if it's not an
// intended thing, then an error toast is fine"). The control that started it
// keeps what was typed; the toast is the only report.

const FALLBACK = "The change was not saved.";

export function toastWriteFailure(error: unknown): void {
  const message =
    error instanceof Error && error.message.trim() !== ""
      ? error.message
      : FALLBACK;
  window.openFpToast(message, "error");
}
